import clsx from "clsx";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
const useStyles = makeThemedStyles("SideBar", (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minWidth: "220px",
    gap: "20px",
    margin: "0px",
    padding: "10px",
  },
}));

const SideBar = (props: React.PropsWithChildren<{ className?: string }>) => {
  const styles = useStyles();
  return (
    <div className={clsx(styles.container, props.className || "")}>
      {props.children}
    </div>
  );
};

export default SideBar;
